<div class="section-loader body-bg" *ngIf="loading">
  <div class="loader-inner ball-beat">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
<div class="scroll page-bg flex-fill overflow-auto py-3 px-5 centerform">
  <div class="container p-0">
    <form [formGroup]="eventSignupForm" (ngSubmit)="updateEventSignUp(eventSignupForm.value)">
      <div class="mControls">
        <div class="input-group mr-auto">
          <h1 class="m-0 text-white align-items-center d-inline-flex">
            {{editEventSignup? 'Update ' + eventSignupEdit?.title : 'Create New Link'}}
          </h1>
        </div>
        <div class="mControls__right">
          <div class="input-group">
            <button type="button" mat-raised-button (click)="navigateToEventSignUp()"> Cancel
            </button>
          </div>
          <div class="input-group" *ngIf="editEventSignup">
            <button color="primary" mat-raised-button [disabled]="!eventSignupForm.valid"> Update
            </button>
          </div>
          <div class="input-group" *ngIf="!editEventSignup">
            <button color="primary" mat-raised-button type="submit" [disabled]="!eventSignupForm.valid">Done
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-7 mb-3">
          <div class="card">
            <div class="card-header">General</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Title</mat-label>
                    <input placeholder="Title" maxlength="255" matInput name="title" id="title" type="text" formControlName="title" required>
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Description</mat-label>
                    <textarea name="description" type="text" matInput name="description" id="description"
                      placeholder="Description" formControlName="description" matInput cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="12" cdkAutosizeMaxRows="12" required></textarea>
                  </mat-form-field>
                </div>

                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Link</mat-label>
                    <input placeholder="Link" matInput name="link" id="link" type="text" formControlName="link" required>
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Sort Order</mat-label>
                    <input placeholder="Sort  order" matInput name="sort_order" id="sort_order" type=text
                      formControlName="sort_order" pattern=^[1-9][0-9]*$ maxlength="10" required>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5 mb-3">
          <div class="card">
            <div class="card-header">Summary</div>
            <div class="card-body">
              <strong>Icon</strong>
              <div class="icons-wrapper">
                <div class="icons-list">
                  <div class="icon-48">
                    <img class="center-block" src="assets/images/training-icon.png"
                      [class.active-icon]="activeIcon === 'training'" (click)="setActiveIcon('training')" alt="">
                  </div>
                </div>
                <div class="icons-list">
                  <div class="icon-48">
                    <img class="center-block" src="assets/images/speaker-icon.png"
                      [class.active-icon]="activeIcon === 'speaker'" (click)="setActiveIcon('speaker')" alt="">
                  </div>
                </div>
                <div class="icons-list">
                  <div class="icon-48">
                    <img class="center-block" src="assets/images/tutor-icon.png"
                      [class.active-icon]="activeIcon === 'tutoring'" (click)="setActiveIcon('tutoring')" alt="">
                  </div>
                </div>
                <div class="icons-list">
                  <div class="icon-48">
                    <img class="center-block" src="assets/images/volunteer-icon.png"
                      [class.active-icon]="activeIcon === 'volunteer'" (click)="setActiveIcon('volunteer')" alt="">
                  </div>
                </div>
                <div class="icons-list">
                  <div class="icon-48">
                    <img class="center-block" src="assets/images/book-icon.png"
                      [class.active-icon]="activeIcon === 'reading'" (click)="setActiveIcon('reading')" alt="">
                  </div>
                </div>
                <div class="icons-list">
                  <div class="icon-48">
                    <img class="center-block" src="assets/images/calendar-icon.png"
                      [class.active-icon]="activeIcon === 'upcoming'" (click)="setActiveIcon('upcoming')" alt="">
                  </div>
                </div>
                <div class="icons-list">
                  <div class="icon-48">
                    <img class="center-block" src="assets/images/list-icon.png"
                      [class.active-icon]="activeIcon === 'list'" (click)="setActiveIcon('list')" alt="">
                  </div>
                </div>
                <div class="icons-list">
                  <div class="icon-48">
                    <img class="center-block" src="assets/images/miscellaneous-icon.png"
                      [class.active-icon]="activeIcon === 'miscellaneous'" (click)="setActiveIcon('miscellaneous')"
                      alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
